import { render, staticRenderFns } from "./MainMenuItem.vue?vue&type=template&id=9b1e3070"
import script from "./MainMenuItem.vue?vue&type=script&lang=js"
export * from "./MainMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports